import Section from "../../common/section";
import SimpleTextSection from "../../section/simpleText";
import { forwardRef, type LegacyRef } from "react";
import InsightBand from "./insightBand";

export type ResourceProps = {};
const ResourceSection = (
  props: ResourceProps,
  ref: LegacyRef<HTMLElement> | undefined,
) => {
  return (
    <>
      <InsightBand />
      <Section ref={ref}>
        {/* replace 'Coming Soon' once content is ready */}
        <SimpleTextSection theme="light" title={"Coming Soon..."} />
      </Section>
    </>
  );
};

export default forwardRef(ResourceSection);
